export default __webpack_public_path__ + "static/media/play_light.37c4d731.svg";